module.exports = __webpack_public_path__ + "static/img/newbook1.140ab2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/newbook1.png
// module id = Dn4N
// module chunks = 0